import React from 'react'
import { Fade, Modal } from '@mui/material'
import View from '@modul-connect/shared/components/atoms/view'
import Button from '@modul-connect/shared/components/atoms/button'
import TextField from '@modul-connect/shared/components/molecules/textField'
import { H1 } from '@modul-connect/shared/components/atoms/text'
import { useEffect } from 'react'
import modal from '@modul-connect/shared/components/atoms/modal'

const EditLicenseNumberModal = ({ 
    openModal,
    onClose,
    vehicleId,
    commit,
    disabled,
    saving,
    updateFailed
}) => {
    const [newValue, setNewValue] = React.useState(null)
    const [error, setError] = React.useState(false)
    const [errorText, setErrorText] = React.useState("")

    useEffect(() => {
        if(openModal) {
            setNewValue(null)
            setError(false)
        }
    }, [openModal])

    useEffect(() => {
        if(updateFailed) {
            setError(true)
        }
    })

    useEffect(() => {
        if(saving && saving.progress === 'failed') {
            setError(true)
            setErrorText(' - Update failed.')
        }
        if (saving && saving.progress == null) {
            closeModal()
        }
    }, [saving])

    const onSave = () => {
        setErrorText('')
        setError(false)

        const data = {
            licenseNumber: newValue,
            vehicleId: vehicleId
        }

        commit(data)
    }

    const closeModal = () => {
        setErrorText('')
        setError(false)
        onClose() 
    }

    return (
        <Modal
            open={ openModal }
            onClose={(event, reason) => {
              if (disabled && reason === 'backdropClick') {
                return
              }
              onClose()
            }}            
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
        >
            <Fade in={ openModal }>
                <div >
                    <View extend={ modal.container }>
                        <View extend={ modal.header }>
                            <H1 text={"Edit License Number"}/>
                        </View>
                        <View extend={ modal.content }>
                            <TextField
                                name="License Number"
                                placeholder={''}
                                disabled={ disabled }
                                error={error}
                                errorText={ errorText }
                                onChange={e => setNewValue(e.target.value)}
                            />
                        </View>
                        <View extend={ modal.footer }>
                            <Button noBg disabled={ disabled } cancel onClick={ closeModal }>
                                Cancel
                            </Button>
                            <Button noBg disabled={ disabled || !newValue } noPadding onClick={ onSave }>
                                Submit
                            </Button>
                        </View>
                    </View>
                </div>
            </Fade>
        </Modal>
    )
}

export default EditLicenseNumberModal
